export default "__VITE_ASSET__206e1ff3__"